import { useMutation } from "@tanstack/react-query";
import { Button, FormControl, GKModal, GKTextField, Grid2 } from "components";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import axiosInstance from "utils/axiosInstance";

interface Props {
  open: boolean;
  setOpen: (value: boolean) => void;
  telegramData?: any;
  refetch: any;
}

const TelegramModal = (props: Props) => {
  const { open, setOpen, telegramData, refetch } = props;

  const { mutate: handleCreateTelegramBot } = useMutation({
    mutationKey: ["CREATE_TELEGRAM_BOT"],
    mutationFn: (data: any) => axiosInstance.post(`/telegram-bots/`, data),
    onSuccess: (response) => {
      refetch();
      setOpen(false);
      toast.success(response?.data?.message || "Create Group Successfully");
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
  });

  const { mutate: handleUpdateTelegramBot } = useMutation({
    mutationKey: ["UPDATE_TELEGRAM_BOT"],
    mutationFn: (data: any) =>
      axiosInstance.put(`/telegram-bots/${telegramData?.id}/`, data),
    onSuccess: (response) => {
      refetch();
      setOpen(false);
      toast.success(response?.data?.message || "Create Group Successfully");
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
  });

  const formik = useFormik({
    initialValues: {
      name: telegramData?.name || "",
      botToken: telegramData?.botToken || "",
      telegramId: telegramData?.telegramId || "",
      firstName: telegramData?.firstName || "",
    },
    onSubmit: (values) => {
      if (telegramData?.id) {
        handleUpdateTelegramBot(values);
      } else {
        handleCreateTelegramBot(values);
      }
    },
  });

  return (
    <GKModal
      modalTitle={
        telegramData?.id ? "Update Telegram Bot" : "Create Telegram Bot"
      }
      open={open}
      setOpen={setOpen}
      footer={
        <Grid2 container justifyContent={"flex-end"} gap={1}>
          <Button variant="outlined" onClick={() => setOpen(false)}>
            Close
          </Button>
          <Button type="submit" form="create-telegram-bot" variant="contained">
            {telegramData?.id ? "Update" : "Submit"}
          </Button>
        </Grid2>
      }
    >
      <form id="create-telegram-bot" onSubmit={formik.handleSubmit}>
        <Grid2 container spacing={2}>
          <Grid2 size={6}>
            <FormControl variant="standard" fullWidth>
              <GKTextField
                inputLabel="Name"
                name="name"
                value={formik.values.name}
                onChange={formik?.handleChange}
                required
              />
            </FormControl>
          </Grid2>
          <Grid2 size={6}>
            <FormControl variant="standard" fullWidth>
              <GKTextField
                inputLabel="First Name"
                name="firstName"
                value={formik.values.firstName}
                onChange={formik?.handleChange}
                required
              />
            </FormControl>
          </Grid2>
          <Grid2 size={6}>
            <FormControl variant="standard" fullWidth>
              <GKTextField
                inputLabel="Bot Token"
                name="botToken"
                value={formik.values.botToken}
                onChange={formik?.handleChange}
                required
              />
            </FormControl>
          </Grid2>
          <Grid2 size={6}>
            <FormControl variant="standard" fullWidth>
              <GKTextField
                inputLabel="Telegram Id"
                name="telegramId"
                value={formik.values.telegramId}
                onChange={formik?.handleChange}
                required
              />
            </FormControl>
          </Grid2>
        </Grid2>
      </form>
    </GKModal>
  );
};

export default TelegramModal;
